import React, { useCallback, useEffect } from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import cogoToast from 'cogo-toast';

import { useMoveLibraryAcademyTopicMutation } from 'features/classCreation';

function LibraryClassesDragDrop({ children, orderedClasses }) {
  const [moveLibraryAcademyTopic, { error, isLoading: isMoving }] =
    useMoveLibraryAcademyTopicMutation();

  const handleDragEnd = useCallback(
    (result) => {
      // dropped outside the list
      if (!result.destination) {
        return;
      }

      // no movement
      if (result.destination.index === result.source.index) {
        return;
      }

      const sourceLibraryAcademyTopic = orderedClasses[result.source.index];
      const destLibraryAcademyTopic = orderedClasses[result.destination.index];

      // We expect draggableId and source id to be same else something is
      // very wrong and we simply avoid making any changes.
      if (String(sourceLibraryAcademyTopic.id) !== result.draggableId) {
        return;
      }

      // If there is no destination class then also something is wrong so
      // we avoid making any changes.
      if (!destLibraryAcademyTopic) {
        return;
      }

      moveLibraryAcademyTopic({
        id: sourceLibraryAcademyTopic.id,
        libraryId: sourceLibraryAcademyTopic.library_id,
        newOrder: destLibraryAcademyTopic.order,
      });
    },
    [moveLibraryAcademyTopic, orderedClasses]
  );

  useEffect(() => {
    if (error) {
      const message =
        error.data?.message ||
        'Failed to move class, please try again after sometime!';
      cogoToast.error(message);
    }
  }, [error]);

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      {children({ isMoving })}
    </DragDropContext>
  );
}

export default LibraryClassesDragDrop;
